import { Modal, Button, Row, Col, Input, message } from "antd";
import React, { useState } from "react";
import "../../styles/db.css";
import { showNotice } from "../../helper/notify";
import {
  createJob,
  fileToSpecCompareMultiPart,
  updateJob,
  pollJobStatus,
} from "../../service/run.service";
import { useUser } from "../../context/UserContext";
const { TextArea } = Input;

/* Ru File to Specification from Test Suite *?* */

function RunTaskModal(props) {
  const { email } = useUser();
  const [file, setFile] = useState();
  const [fileName, setFileName] = useState("");
  const [errorColor, setErrorColor] = useState("black");
  const handleModal = () => {
    props.openModal(false);
  };
  const onFileUploadClick = (e) => {
    setFile(e.target.files[0]);
    setFileName(e.target.files[0].name);
  };

  const onClickRun = () => {
    let taskType = "On Demand";
    let taskCategory = "Compare";
    let taskSubCategory = "File to Specification";
    if (fileName.length < 1) {
      message.error("Please upload a file to test!");
      setErrorColor("red");
    } else {
      handleModal();
      createJob(
        taskType,
        taskCategory,
        taskSubCategory,
        "In Progress",
        email,
        "File to Specification",
        "Not Applicable",
      ).then((res) => {
        if (res.status == 200) {
          let jobId = res.data.jobId;
          fileToSpecCompareMultiPart(
            jobId,
            props.suiteName,
            props.suiteId,
            file,
            props.specName,
            taskCategory,
            taskSubCategory,
            taskType,
            "Job",
          )
            .then(() => {
              // Backend now runs the compare asynchronously and owns the job
              // status — track it in the Job Queue and poll for completion.
              showNotice(
                "info",
                "Run started",
                "File to Specification is running — track it in the Job Queue.",
              );
              pollJobStatus(jobId)
                .then(() =>
                  showNotice(
                    "success",
                    "Run complete",
                    "File to Specification completed.",
                  ),
                )
                .catch((job) =>
                  showNotice(
                    "error",
                    "Run failed",
                    job?.errorDescription || "The run did not complete.",
                  ),
                );
            })
            .catch((err) => {
              updateJob(jobId, "Error", err.code, err.message);
              showNotice("error", err.code, err.message);
            });
        }
      });
    }
  };

  return (
    <div>
      <Modal
        centered
        open={props.isOpen}
        destroyOnClose
        footer={[
          <Button key="back" onClick={onClickRun}>
            Run
          </Button>,
          <Button key="submit" type="primary" onClick={handleModal}>
            Cancel
          </Button>,
        ]}
        onCancel={handleModal}
      >
        <Row style={{ paddingBottom: "20px" }}>
          <p className="modal-header-text">Run Test Suite</p>
        </Row>
        <Row>
          <Col span={6}>
            <p className="spec-modal-label">Category :</p>
          </Col>
          <Col span={18}>
            <p>Compare</p>
          </Col>
        </Row>
        <Row>
          <Col span={6}>
            <p className="spec-modal-label">Sub-Category :</p>
          </Col>
          <Col span={18}>
            <p>File to Specification</p>
          </Col>
        </Row>
        <Row>
          <Col span={6}>
            <p className="spec-modal-label">Test Suite :</p>
          </Col>
          <Col span={18}>
            <p>{props.suiteName}</p>
          </Col>
        </Row>
        <Row>
          <Col span={6} className="spec-modal-label">
            Comments :
          </Col>
          <Col span={18}>
            <p>
              <TextArea
                placeholder="comment/description"
                autoSize={{
                  minRows: 3,
                  maxRows: 5,
                }}
              />
            </p>
          </Col>
        </Row>
        <p>
          *{" "}
          <input
            type="file"
            onChange={onFileUploadClick}
            style={{ color: errorColor }}
          />
        </p>
      </Modal>
    </div>
  );
}

export default RunTaskModal;
